/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts,updateCategory,setQuote,initQuote,setLogo, setTotalPrice} from '../actions/quote'
import Category from "./Category.js"
import {supplier_arry} from "../config"
import { toast } from 'react-toastify';

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";
import logo_small_yellow from "assets/img/brand/logo_small_yellow.jpg"
import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
import Product from "./IndexSections/Product.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";






// fake data generator
const getItems = (count, offset = 0) =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k + offset}-${new Date().getTime()}`,
    content: `item ${k + offset}`
  }));

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};
const grid = 8;

const getItemStyle = (isDragging, draggableStyle, index) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 0 0`,

  // change background colour if dragging
  background: isDragging ? "lightgreen" : (index%2==0?"white":"#EDECEF"),
  display:'flex',
  width:'100%',
  // styles we need to apply on draggables
  ...draggableStyle
});
const getHeaderStyle = ()=>({
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 0 0`,
  background:'#091E3F',
  fontWeight:'normal',
  display:'flex',
  width:'100%',
  color:'white',
  borderTopLeftRadius: '20px',
  borderTopRightRadius: '20px'
})
const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: 0,
  width: '100%',
  borderBottom: '6px solid #091E3F',
  minHeight:'80px',
  // marginBottom:'20px'
});

function Index(props) {
  
  useEffect(() => {
  },[props.quote]);

  const getCategorySum = ()=>{
    var sum = 0;
    const quote = props.quote;
    const categories = quote.categories;
    for(var index in categories){
      const category = categories[index]
      var removed_fee = category['removed_fee'];
      var groups = category.items
      if(groups){
        var group = groups[0];
        var group_options = group['group_options'];
        for(var loop = 0; loop< supplier_arry.length; loop++){
          var catalog = supplier_arry[loop]['key'];
          if(group_options && group_options['cat_fee_'+catalog]){
            if(!removed_fee || (removed_fee && removed_fee.length == 0) || (removed_fee && !removed_fee.includes(catalog))){
              sum+= (group_options['cat_fee_'+catalog]*1)
            }
          }
        }
      }
    }
    return sum;
  }
  const totalMargin=()=>{
   
  }
  const totalMarginPercent=()=>{
    
  }
  var role = props.role
  return (
    <>
      <div style={{padding:'20px 5px', background:'transparent'}}>
        <div className="d-flex">
                
        </div>
          <div className="d-flex back-to-top">
            <div style={{width:240}} >
              <div className="align-items-center" style={{display:'inline-flex', cursor:'pointer'}} onClick={()=>{window.scrollTo(0, 0);}}>
                <img className="" width="22px" src={logo_small_yellow}/>
                <span style={{fontSize:36}} className="material-icons">expand_less</span>
                <b>Back to Top</b>
              </div>
            </div>
            {role == 'admin' &&
            <div className="cost-field" >
              <div className="cost-field" style={{width:420, borderBottom:'1px solid #091e3f'}}>
                <div className="d-flex">
                  <label className="text-right" style={{width:240}}><b>GROSS PROFIT MARGIN</b></label>
                  <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
                  <label className="text-center" style={{width:60}}><span className="cost-field">&nbsp;</span>&nbsp;</label>
                  <label className="text-center" style={{width:60}}>{(props.quote.marginValue?props.quote.marginValue*1:0).toFixed(2)}</label>
                </div>
                <div className="d-flex">
                  <label className="text-right" style={{width:240}}><b>GROSS PROFIT %</b></label>
                  <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
                  <label className="text-center" style={{width:60}}><span className="cost-field">&nbsp;</span>&nbsp;</label>
                  <label className="text-center" style={{width:60}}>{(props.quote.marginPercent?props.quote.marginPercent*1:0).toFixed(2)}</label>
                </div>
              </div>
            </div>
            }
            
          </div>
          
         
         <div className="d-flex">
            <div style={{width:240}} className="d-flex align-items-center">
            </div>
            <div style={{width:420}} className="text-right ">
              <img className="mt-2" width="264px" src={require(`assets/img/brand/sign_small.jpg`).default}/>
            </div>
            
          </div>
      </div>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    setTotalPrice: value=>dispatch(setTotalPrice(value)),
    updateCategory: cat=>dispatch(updateCategory(cat)),
    setQuote: quote=>dispatch(setQuote(quote)),
    initQuote:()=>dispatch(initQuote()),
    setLogo:logo=>dispatch(setLogo(logo)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
